import { createSelector } from '@reduxjs/toolkit';

import { alphaSort } from 'bones/utils/sort/alphaSort';
import { resultLabelsByIriSelector } from 'bones/utils/store/dataCatalog/selectors/resultLabelsByIri';
import { DataCatalogState } from 'bones/utils/store/dataCatalog/types';

export const resultIrisSelector = (limit?: number) =>
  createSelector(
    resultLabelsByIriSelector,
    (state: DataCatalogState) => state.searchResultIris,
    (state: DataCatalogState) => state.dataSourcesByIri,
    (state: DataCatalogState) => state.catalogsByIri,
    (state: DataCatalogState) => state.schemasByIri,
    (state: DataCatalogState) => state.tablesByIri,
    (state: DataCatalogState) => state.columnsByIri,
    (
      labelsByIri,
      resultIris,
      dataSourcesByIri,
      catalogsByIri,
      schemasByIri,
      tablesByIri,
      columnsByIri
    ) =>
      resultIris
        .filter(
          (resultIri) =>
            dataSourcesByIri[resultIri] ||
            catalogsByIri[resultIri] ||
            schemasByIri[resultIri] ||
            tablesByIri[resultIri] ||
            columnsByIri[resultIri]
        )
        .sort(alphaSort((resultIri) => labelsByIri[resultIri]))
        .slice(0, limit)
  );

export const dataSourceResultIrisSelector = createSelector(
  resultIrisSelector(),
  (state: DataCatalogState) => state.dataSourcesByIri,
  (resultIris, resultsByIri) => resultIris.filter((iri) => resultsByIri[iri])
);

export const catalogResultIrisSelector = createSelector(
  resultIrisSelector(),
  (state: DataCatalogState) => state.catalogsByIri,
  (resultIris, resultsByIri) => resultIris.filter((iri) => resultsByIri[iri])
);

export const schemaResultIrisSelector = createSelector(
  resultIrisSelector(),
  (state: DataCatalogState) => state.schemasByIri,
  (resultIris, resultsByIri) => resultIris.filter((iri) => resultsByIri[iri])
);

export const tableResultIrisSelector = createSelector(
  resultIrisSelector(),
  (state: DataCatalogState) => state.tablesByIri,
  (resultIris, resultsByIri) => resultIris.filter((iri) => resultsByIri[iri])
);

export const columnResultIrisSelector = createSelector(
  resultIrisSelector(),
  (state: DataCatalogState) => state.columnsByIri,
  (resultIris, resultsByIri) => resultIris.filter((iri) => resultsByIri[iri])
);
